import { useEffect, useState } from "react";
import { Box, Tooltip } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";

const TextToSpeech = ({ text }) => {
  const [isSpeaking, setIsSpeaking] = useState(false);

  // Detener la voz si el componente se desmonta
  useEffect(() => {
    return () => {
      window.speechSynthesis.cancel();
    };
  }, []);

  const handleSpeech = () => {
    // Si ya está hablando, detener
    if (isSpeaking) {
      window.speechSynthesis.cancel();
      setIsSpeaking(false);
      return;
    }

    // Verificar compatibilidad
    if (!("speechSynthesis" in window)) {
      console.error("El navegador no soporta síntesis de voz.");
      return;
    }

    // Limpiar cualquier reproducción anterior
    window.speechSynthesis.cancel();

    const speech = new SpeechSynthesisUtterance(text);

    // Configuración de la voz
    speech.lang = "es-MX";
    speech.rate = 0.9;
    speech.pitch = 1;
    speech.volume = 1;

    speech.onstart = () => {
      setIsSpeaking(true);
    };

    speech.onend = () => {
      setIsSpeaking(false);
    };

    speech.onerror = () => {
      setIsSpeaking(false);
    };

    window.speechSynthesis.speak(speech);
  };

  return (
    <Tooltip
      title={isSpeaking ? "Detener lectura" : "Escuchar información"}
      placement="left"
    >
      <Box
        onClick={handleSpeech}
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="fixed"
        bottom={140}
        right={0}
        width={60}
        height={60}
        m="0 15px 15px 0"
        borderRadius="50%"
        zIndex={10}
        bgcolor={isSpeaking ? "#D32F2F" : "#1976D2"}
        sx={{
          cursor: "pointer",
          boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
          transition: "all 0.3s ease",

          "&:hover": {
            transform: "scale(1.08)",
            boxShadow: "0 6px 18px rgba(0,0,0,0.35)",
          },

          "&:active": {
            transform: "scale(0.95)",
          },
        }}
      >
        {isSpeaking ? (
          <VolumeOffIcon
            sx={{
              height: "2.2em",
              width: "auto",
              color: "white",
            }}
          />
        ) : (
          <VolumeUpIcon
            sx={{
              height: "2.2em",
              width: "auto",
              color: "white",
            }}
          />
        )}
      </Box>
    </Tooltip>
  );
};

export default TextToSpeech;